/**
 * @generated SignedSource<<50041a220d976a36589bc8a83506559e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type SlaStatus = "breached" | "paused" | "%future added value";
export type TicketChannel = "manual" | "email" | "phone" | "chat" | "internal" | "api" | "customer_portal" | "direct" | "%future added value";
export type TicketPriority = "p0" | "p1" | "p2" | "p3" | "%future added value";
export type TicketRollupGroupBy = "status" | "priority" | "assignee" | "channel" | "requester" | "%future added value";
export type TicketStatus = "open" | "in_progress" | "waiting_on_customer" | "resolved" | "closed" | "%future added value";
export type TicketDashboardRollupsInput = {
  groupBy?: TicketRollupGroupBy | null;
  status?: ReadonlyArray<TicketStatus> | null;
  priority?: ReadonlyArray<TicketPriority> | null;
  channel?: ReadonlyArray<TicketChannel> | null;
  assigneeId?: ReadonlyArray<string> | null;
  includeUnassigned?: boolean | null;
  requesterId?: ReadonlyArray<string> | null;
  labelId?: ReadonlyArray<string> | null;
  search?: string | null;
  slaStatus?: ReadonlyArray<SlaStatus> | null;
  createdAfter?: string | null;
  createdBefore?: string | null;
  updatedAfter?: string | null;
  updatedBefore?: string | null;
  resolvedAfter?: string | null;
  resolvedBefore?: string | null;
  lastActivityAfter?: string | null;
  lastActivityBefore?: string | null;
  firstResponseAfter?: string | null;
  firstResponseBefore?: string | null;
};
export type useDashboardRollupsQuery$variables = {
  rollupInput: TicketDashboardRollupsInput;
};
export type useDashboardRollupsQuery$data = {
  readonly viewer: {
    readonly ticketDashboardRollups: {
      readonly overall: {
        readonly total: number;
        readonly resolvedCount: number;
        readonly pctResolved: number | null;
        readonly medianResolutionTimeSeconds: number | null;
        readonly medianFirstResponseTimeSeconds: number | null;
        readonly slaAchievementRate: number | null;
      };
      readonly groups: ReadonlyArray<{
        readonly key: string;
        readonly rollup: {
          readonly total: number;
          readonly resolvedCount: number;
          readonly pctResolved: number | null;
          readonly medianResolutionTimeSeconds: number | null;
          readonly medianFirstResponseTimeSeconds: number | null;
          readonly slaAchievementRate: number | null;
        };
      }> | null;
    } | null;
  } | null;
};
export type useDashboardRollupsQuery = {
  variables: useDashboardRollupsQuery$variables;
  response: useDashboardRollupsQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "rollupInput"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "total",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "resolvedCount",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "pctResolved",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "medianResolutionTimeSeconds",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "medianFirstResponseTimeSeconds",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "slaAchievementRate",
    "storageKey": null
  }
],
v2 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "rollupInput"
    }
  ],
  "concreteType": "TicketDashboardRollups",
  "kind": "LinkedField",
  "name": "ticketDashboardRollups",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "TicketRollup",
      "kind": "LinkedField",
      "name": "overall",
      "plural": false,
      "selections": (v1/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "TicketGroupRollup",
      "kind": "LinkedField",
      "name": "groups",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "key",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "TicketRollup",
          "kind": "LinkedField",
          "name": "rollup",
          "plural": false,
          "selections": (v1/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useDashboardRollupsQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useDashboardRollupsQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "7f92ca84d255e3abba13355e1ddf12e3",
    "id": null,
    "metadata": {},
    "name": "useDashboardRollupsQuery",
    "operationKind": "query",
    "text": "query useDashboardRollupsQuery(\n  $rollupInput: TicketDashboardRollupsInput!\n) {\n  viewer {\n    ticketDashboardRollups(input: $rollupInput) {\n      overall {\n        total\n        resolvedCount\n        pctResolved\n        medianResolutionTimeSeconds\n        medianFirstResponseTimeSeconds\n        slaAchievementRate\n      }\n      groups {\n        key\n        rollup {\n          total\n          resolvedCount\n          pctResolved\n          medianResolutionTimeSeconds\n          medianFirstResponseTimeSeconds\n          slaAchievementRate\n        }\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "9fb1fb654c856f84506a2cf34f398315";

export default node;
